module.exports = __webpack_public_path__ + "assets/img/w-c-s1.2741b0f2.png";